export let primaryColor = "#0be779";
export let secondaryColor = "#39b175";
export let primaryBackgroundColor = "#272b33";
export let secondaryBackgroundColor = "#2c323f";
